import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-8 py-24 md:py-32 flex flex-col items-center justify-center text-center">
        <span className="font-heading font-black text-[7rem] md:text-[10rem] leading-none text-primary-200 select-none">
          404
        </span>
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-2">
          页面走丢了
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-md">
          你访问的页面不存在或已被移除，不如回到首页，继续发现好看的电影吧。
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-700 text-sm font-label hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-apps-2-line"></i>
            浏览电影分类
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}